import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  getAppointmentBirthday,
  getAppointmentCountryCode,
  getAppointmentEmail,
  getAppointmentFirstName,
  getAppointmentLastName,
  getAppointmentNationalPhone,
} from "../../core/store/appointmentSlice";
import { useMainStore } from "../../core/store/mainStore";
import { useHandleAppointmentBookingNavigation } from "../navigation/utils/useHandleAppointmentBookingNavigation";
import { AppointmentContactComponent } from "./components/AppointmentContactComponent";
import { useAppointmentContactRequirements } from "./utils/useAppointmentContactRequirements";
import { useCompleteAppointment } from "./utils/useCompleteAppointment";

export const AppointmentContactScreen = () => {
  const handleComplete = useCompleteAppointment();
  const { t } = useTranslation();
  const navigate = useHandleAppointmentBookingNavigation();
  const [loading, setLoading] = useState(false);

  const firstName = useMainStore(getAppointmentFirstName);
  const setAppointmentFirstName = useMainStore(
    (state) => state.setAppointmentFirstName,
  );
  const lastName = useMainStore(getAppointmentLastName);
  const setAppointmentLastName = useMainStore(
    (state) => state.setAppointmentLastName,
  );
  const email = useMainStore(getAppointmentEmail);
  const setAppointmentEmail = useMainStore(
    (state) => state.setAppointmentEmail,
  );
  const birthday = useMainStore(getAppointmentBirthday);
  const setAppointmentBirthday = useMainStore(
    (state) => state.setAppointmentBirthday,
  );
  const { showEmail, showBirthday, birthdayRequired } =
    useAppointmentContactRequirements();
  const nationalPhone = useMainStore(getAppointmentNationalPhone);
  const setAppointmentNationalPhone = useMainStore(
    (state) => state.setAppointmentNationalPhone,
  );
  const countryCode = useMainStore(getAppointmentCountryCode);
  const setAppointmentCountryCode = useMainStore(
    (state) => state.setAppointmentCountryCode,
  );

  const handleNext = async () => {
    setLoading(true);
    try {
      await handleComplete();
      navigate();
    } catch (error) {
      console.error("Error completing appointment:", error);
      // Optionally, set some error state here to inform the user
    } finally {
      setLoading(false);
    }
  };

  return (
    <AppointmentContactComponent
      headline={t("APPOINTMENT_CONTACT_HEADLINE")}
      subtitle={t("APPOINTMENT_CONTACT_SUBTITLE")}
      handleNext={handleNext}
      data={{
        firstName,
        lastName,
        email,
        birthday,
        nationalPhone,
        countryCode,
      }}
      setData={{
        setAppointmentFirstName,
        setAppointmentLastName,
        setAppointmentEmail,
        setAppointmentBirthday,
        setAppointmentNationalPhone,
        setAppointmentCountryCode,
      }}
      showEmail={showEmail}
      showBirthday={showBirthday}
      birthdayRequired={birthdayRequired}
      loading={loading}
      nextButtonText={t("APPOINTMENT_SUBMIT_REQUEST")}
    />
  );
};
